import { AppConfig } from '../../app-services/config/config.app';
import { Enums } from '../../enums/enums';
import { AbstractEndpoints, IAdvertisementEndpoints, IAuthorizationEndpoints, IAzureStorageEndpoints, ICampaignInsightsEndpoints, ICampaignsEndpoints, IMenuEndpoints, INotificationEndpoints, IOrganizationEndpoints, ITokenEndpoints } from './endpoints.service.abstract';


export class EndpointsMock implements AbstractEndpoints {

    advertisement: IAdvertisementEndpoints;
    authorization: IAuthorizationEndpoints;
    azureStorage: IAzureStorageEndpoints;
    campaigns: ICampaignsEndpoints;
    campaignInsights: ICampaignInsightsEndpoints;
    menu: IMenuEndpoints;
    notifications: INotificationEndpoints;
    organization: IOrganizationEndpoints;
    token: ITokenEndpoints;


    constructor(private readonly appConfig: AppConfig) {

        this.advertisement = {
            deleteAdvertisement: (organizationId: string, advertisementId: string): string => {
               return `${this.appConfig.apiBaseURLs.campaigns}/api/DeleteAdvertisement?organizationId=${organizationId}&advertisementId=${advertisementId}`;
            }
        };

        this.authorization = {
            login: `${this.appConfig.apiBaseURLs.azureB2C}/accountsFromB2C`,
            passwordReset: 'NA',
            profileEdit: 'NA',
            signup: `${this.appConfig.apiBaseURLs.azureB2C}/accountsFromB2C`,
            loginRedirect: 'http://localhost:4200/',
            registerRedirect: 'http://localhost:4200/new-user-wizard'
        };
        
        this.azureStorage = {
            base:  `${appConfig.azureStorage.storageURL}/${appConfig.azureStorage.baseContainerName}`
        };

        this.campaigns = {
            campaignConfig: (organizationId: string, campaignId: string): string => {
                return `${this.appConfig.azureStorage.storageURL}/${organizationId}/${campaignId}/${appConfig.azureStorage.campaignFileName}`;
            },
            campaignRedirectFile: (organizationId: string, campaignId: string): string => {
                return `${this.appConfig.azureStorage.storageURL}/${organizationId}/${campaignId}/${Enums.FileNames.REDIRECT_CAMPAIGN}`;
            },
            campaignSubscriptionFile: (organizationId: string, campaignId: string): string => {
                return `${this.appConfig.azureStorage.storageURL}/${organizationId}/${campaignId}/${appConfig.azureStorage.subscriptionsFilename}`;
            }
        };

        this.campaignInsights = {
            getPageViews: (url: string, startDate: Date, endDate: Date): string => {
                return `${this.appConfig.apiBaseURLs.applicationInsights}/pageViews?searchValue=${url}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
            }
        };

        this.menu = {
            loadMenuFile: (organizationId: string, campaignId: string): string => {
                return `${this.appConfig.azureStorage.storageURL}/${organizationId}/${campaignId}/${appConfig.azureStorage.menuFileName}`;
            }
        };

        this.notifications = {
            sendNotification: `${this.appConfig.apiBaseURLs.campaigns}/api/SendNotification`
        };

        this.organization = {
            updateOrganization: `${this.appConfig.apiBaseURLs.cosmosDB}/api/UpdateUserOrganizations`,
            organizationSubscriptionFile: (organizationId: string): string => {
                return `${this.appConfig.azureStorage.storageURL}/${organizationId}/${appConfig.azureStorage.subscriptionsFilename}`;
            }
        }

        this.token = {
            getSASCRUDToken: (containerName: string) => `${this.appConfig.apiBaseURLs.anonymousAccess}?containerName=${this.appConfig.azureStorage.baseContainerName}`,
            getSASAppendToken: (fileName: string) => `${this.appConfig.apiBaseURLs.anonymousAccess}?containerName=${this.appConfig.azureStorage.baseContainerName}&file=${fileName}`,
            getSASTokenForFolder: (containerName?: string, folderName?: string): string => `${appConfig.apiBaseURLs.anonymousAccess}/api/GetSASTokenForFolder?containerName=${containerName}&folderPath=${folderName}`
        }
    }
}
